import { combineReducers } from '@reduxjs/toolkit';
import { activateClientUserAuthAccountSlice, deactivateClientUserAuthAccountSlice } from './clientUserAuthAccountSlice';
import {
  actionLenderContactSlice,
  addLenderContactSlice,
  editLenderContactSlice,
  getLenderInfoSlice,
  lenderContactsSlice,
} from './slices';

export const clientLenderContactsReducer = combineReducers({
  lenderContacts: lenderContactsSlice.reducer,
  addLenderContact: addLenderContactSlice.reducer,
  actionLenderContact: actionLenderContactSlice.reducer,
  editLenderContact: editLenderContactSlice.reducer,
  lenderInfo: getLenderInfoSlice.reducer,
  activateClientUserAuthAccountSlice: activateClientUserAuthAccountSlice.reducer,
  deactivateClientUserAuthAccountSlice: deactivateClientUserAuthAccountSlice.reducer,
});
